<template>
  <Nav/>
  <Hero/>
  <Language/>
  <Form/>
  <RegistrationData/>
</template>

<script>
import Nav from './components/Nav.vue'
import Hero from './components/Hero.vue'
import Language from './components/Language.vue'
import Form from './components/Form.vue'
import RegistrationData from './components/RegistrationData'

export default {
  name: 'App',
  components: {
    Nav,
    Hero,
    Language,
    Form,
    RegistrationData
  },
  mounted () {
    this.$store.state.isActivationOpened = false;
    if (window.location.href.includes('activationCode')) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      this.$store.state.activationCodeQS = params.activationCode
    }

    if (window.location.href.includes('activate')) {
      this.$store.state.isActivationOpened = true;
    } else {
      this.$store.state.isActivationOpened = false;
    }

    if (window.location.href.includes('locale')) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      this.$store.state.localeQS = params.locale
    }
  }
}
</script>

<style lang="scss">
/*@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200;400;600;700&display=swap"');*/
@import url('https://fonts.googleapis.com/css2?family=Barlow&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200;400;600;700&display=swap');
/*@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@200;400;600;700&display=swap');*/


@import './assets/scss/main.scss';
</style>
